import React from 'react'

const SvgDoc3 = props => (
  <svg fill='none' width={40} height={40} viewBox='0 0 40 40' {...props}>
    <defs>
      <filter
        id='doc3_svg__a'
        filterUnits='objectBoundingBox'
        colorInterpolationFilters='sRGB'
        x={0}
        y={0}
        width={35}
        height={36}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur in='BackgroundImage' stdDeviation={3.235} />
        <feComposite in2='SourceAlpha' operator='in' result='effect1_foregroundBlur' />
        <feBlend in='SourceGraphic' in2='effect1_foregroundBlur' result='shape' />
      </filter>
    </defs>
    <path
      d='M10.008.514C12.518.19 14.984 0 17.514 0c2.521 0 4.983.19 7.506.514 4.982.642 8.883 4.653 9.507 9.772a63.1 63.1 0 010 15.429c-.625 5.118-4.526 9.13-9.507 9.77-2.51.325-4.977.515-7.506.515-2.522 0-4.984-.19-7.506-.514-4.981-.642-8.883-4.654-9.507-9.771C.185 23.135 0 20.599 0 18c0-2.59.185-5.123.5-7.714.626-5.118 4.527-9.13 9.508-9.772z'
      fill='#FD5C1E'
    />
    <g filter='url(#doc3_svg__a)'>
      <path
        d='M15.008 4.507c2.51-.32 4.976-.507 7.505-.507 2.522 0 4.984.187 7.507.507 4.982.632 8.883 4.587 9.507 9.634.63 5.089.63 10.629 0 15.718-.625 5.046-4.525 9.002-9.507 9.634-2.51.32-4.977.506-7.507.507-2.52 0-4.983-.187-7.505-.507-4.982-.633-8.883-4.588-9.508-9.634a69.91 69.91 0 01-.5-8.113c0-2.553.184-5.05.5-7.605.626-5.046 4.526-9.002 9.508-9.634z'
        fill='#FA9F7C'
        fillOpacity={0.4}
      />
      <path
        d='M15.008 4.507c2.51-.32 4.976-.507 7.505-.507 2.522 0 4.984.187 7.507.507 4.982.632 8.883 4.587 9.507 9.634.63 5.089.63 10.629 0 15.718-.625 5.046-4.525 9.002-9.507 9.634-2.51.32-4.977.506-7.507.507-2.52 0-4.983-.187-7.505-.507-4.982-.633-8.883-4.588-9.508-9.634a69.91 69.91 0 01-.5-8.113c0-2.553.184-5.05.5-7.605.626-5.046 4.526-9.002 9.508-9.634zm.076.601q-3.527.448-6.032 2.986-2.507 2.54-2.95 6.121-.496 4.004-.496 7.531.002 4.06.496 8.039.443 3.58 2.95 6.12 2.504 2.538 6.032 2.987 3.955.502 7.43.502 3.488 0 7.43-.502 3.527-.448 6.032-2.986 2.506-2.54 2.95-6.121.964-7.785 0-15.57-.443-3.58-2.95-6.12-2.504-2.539-6.033-2.987-3.953-.502-7.43-.502-3.49 0-7.429.502z'
        fillRule='evenodd'
        fill='#FFB191'
      />
    </g>
    <path
      d='M24.395 23.151a.427.427 0 01-.27-.355.424.424 0 01.2-.398 5.077 5.077 0 002.375-4.402c-.06-2.657-2.217-4.848-4.918-4.988-2.355-.126-4.502 1.32-5.23 3.523-.728 2.203.144 4.612 2.126 5.868a.422.422 0 01-.073.75c-2.405.975-4.136 3.09-4.59 5.607-.053.31.036.628.243.868s.513.378.833.376H27.91c.321.002.626-.136.833-.377.208-.24.296-.557.243-.867-.454-2.517-2.185-4.63-4.59-5.605z'
      fill='#FFF'
    />
    <path
      d='M32.99 26.195c-.314-1.629-1.508-2.997-3.167-3.627a.279.279 0 01-.185-.23.269.269 0 01.136-.256c1.31-.775 1.926-2.24 1.526-3.627-.4-1.386-1.723-2.376-3.277-2.45a4.144 4.144 0 00-.447.003c.27.652.415 1.342.43 2.04.043 1.702-.683 3.343-2.006 4.532 1.84 1.003 3.242 2.566 3.965 4.42h2.281a.78.78 0 00.575-.243.656.656 0 00.17-.562zM11.01 26.195c.314-1.629 1.508-2.997 3.167-3.627a.279.279 0 00.185-.23.269.269 0 00-.137-.256c-1.309-.775-1.925-2.24-1.525-3.627.4-1.386 1.723-2.376 3.277-2.45.149-.008.298-.006.448.003a5.653 5.653 0 00-.431 2.04c-.043 1.702.683 3.343 2.006 4.532-1.84 1.003-3.242 2.566-3.965 4.42h-2.281a.78.78 0 01-.575-.243.656.656 0 01-.17-.562z'
      fill='#FFF'
    />
  </svg>
)

export default SvgDoc3
